import { useState, useEffect } from "react";
import { FaDoorOpen, FaUserCircle } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";

export default function Navbar({ route, navigation }) {
  const location = useLocation();

  let titre;
  switch (location.pathname) {
    case "/":
      titre = "Login";
      break;
    case "/home":
      titre = "Accueil";
      break;
    case "/menuvehicule":
      titre = "Gestion des vehicules";
      break;
    case "/check":
      titre = "Poste de contrôle";
      break;

    case "/vehicule/ajout":
      titre = "Gestion des vehicules";
      break;

    case "/users":
      titre = "Utilisateurs";
      break;

    case "/menucheckpoint":
      titre = "Poste de contrôle";
      break;

    case "/vehiculepage":
      titre = "Gestion des vehicules";
      break;
    case "/statistiques":
        titre = "Statistiques";
        break;
  

    case "/vehiculepageajout":
      titre = "Gestion des vehicules";
      break;

    case "/avispage":
      titre = "Avis de recherche";
      break;
    case "/vehiculepage/qrcd/:numeroSerie":
      titre = "Gestion des vehicules";
      break;
    case "/vehiculepageajout/qrcd/:numeroSerie":
      titre = "Gestion des vehicules";
      break;
    case "/vehiculepage/qrcd/:numeroSerie":
      titre = "Vehicule";
      break;

    default:
      titre = "";
  }
  //const {titre} = route.params;
  const navigate = useNavigate();

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [newPass2, setNewPass2] = useState("");
  const [profileMsg, setProfileMsg] = useState("");

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setProfileMsg("");
    if (!oldPass || !newPass || !newPass2) {
      setProfileMsg("Tous les champs sont obligatoires.");
      return;
    }
    if (newPass !== newPass2) {
      setProfileMsg("Les nouveaux mots de passe ne correspondent pas.");
      return;
    }
    try {
      const res = await fetch("https://srv968119.hstgr.cloud/users/change-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_user: localStorage.getItem("id_user"),
          oldPassword: oldPass,
          newPassword: newPass,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setProfileMsg("Mot de passe modifié avec succès !");
        setOldPass(""); setNewPass(""); setNewPass2("");
      } else {
        setProfileMsg(data.error || "Erreur lors du changement.");
      }
    } catch {
      setProfileMsg("Erreur réseau.");
    }
  };

  return titre === "Login" ? null : (
    <nav className="fixed top-0 left-0 w-full z-50 flex flex-col items-center">
      {/* Barre principale */}
      <div className="w-full  flex items-center justify-between bg-gradient-to-br from-gray-500 to-gray-900  shadow-lg px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        {/* Logo et titre */}
        <Link to="/home" className="flex flex-col items-center space-x-4">
          <span className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
            SNER-SIV
          </span>
          <span className="hidden sm:inline text-sm md:text-lg text-white/90">
            Système de gestion des plaques
          </span>
        </Link>
        {/* Drapeau */}
        <div className="hidden md:flex items-center">
          <img
            src="/drap.png"
            alt="logo"
            className="w-28 h-20 md:w-40 md:h-28 -ml-12 object-contain"
          />
        </div>
        {/* Utilisateur & Déconnexion & Profil */}
        <div className="flex flex-col items-end">
          <span className="text-white font-semibold text-xl md:text-2xl">
            {localStorage.getItem("nom")}
          </span>

          <button
            className="flex items-center text-blue-100 hover:text-white text-sm md:text-base mt-2"
            onClick={() => setShowProfileModal(true)}
            title="Profil"
          >
            <FaUserCircle className="mr-2 text-2xl" />
           Changer l'accès
          </button>
          <Link
            to="/"
            onClick={() => {
              const numeroSerie = localStorage.getItem("numero_serie");
              localStorage.clear();
              if (numeroSerie) localStorage.setItem("numero_serie", numeroSerie);
            }}
            className="flex items-center text-red-100 hover:text-white text-sm md:text-base mt-2"
          >
            <FaDoorOpen className="mr-2 text-2xl" />
            Déconnexion
          </Link>
        </div>
      </div>
      {/* Barre de titre secondaire */}
      {titre !== "Accueil" && (
        <div className="w-full flex items-center justify-start bg-white/70 dark:bg-slate-800/60 backdrop-blur  mt-0 mb-4 px-3 sm:px-6 py-2 border-1 border-b-13 border-slate-200/60 dark:border-slate-700">
          <button onClick={() => navigate("/home")} className="mr-2">
            <img className="w-8 h-8 sm:w-10 sm:h-10" src="/acueil.png" alt="Accueil" />
          </button>
          <button onClick={() => navigate(-1)} className="mr-4">
            <img className="w-8 h-8 sm:w-10 sm:h-10" src="/back.png" alt="Retour" />
          </button>
          <span className="text-lg sm:text-xl md:text-2xl font-semibold text-black dark:text-gray-200">
            {titre}
          </span>
        </div>
      )}

      {/* Modal Profil */}
      {showProfileModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-sm shadow-lg">
            <h3 className="font-bold text-lg mb-4 text-gray-400 text-center">Changer le mot de passe</h3>
            <form onSubmit={handleProfileSubmit} className="flex flex-col gap-3">
              <input
                type="password"
                placeholder="Ancien mot de passe"
                value={oldPass}
                onChange={e => setOldPass(e.target.value)}
                className="input input-bordered w-full text-gray-200"
                required
              />
              <input
                type="password"
                placeholder="Nouveau mot de passe"
                value={newPass}
                onChange={e => setNewPass(e.target.value)}
                className="input input-bordered w-full text-gray-200"
                required
              />
              <input
                type="password"
                placeholder="Confirmer le nouveau mot de passe"
                value={newPass2}
                onChange={e => setNewPass2(e.target.value)}
                className="input input-bordered w-full"
                required
              />
              {profileMsg && (
                <div className="text-center text-sm text-red-500">{profileMsg}</div>
              )}
              <div className="flex justify-between mt-2">
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setShowProfileModal(false);
                    setProfileMsg("");
                    setOldPass(""); setNewPass(""); setNewPass2("");
                  }}
                >
                  Annuler
                </button>
                <button type="submit" className="btn btn-primary">
                  Enregistrer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </nav>
  );
}
